import {GridHeaderMenuActionTypes} from './header-menu-action-types';
import {GridHeaderMenuTypeChange} from './header-menu-type-changes';

export interface IGridHeaderMenu {
  action: GridHeaderMenuActionTypes;
  colId: string;
  typeOfChange: GridHeaderMenuTypeChange;
  value: boolean;
  sort?: GridHeaderMenuActionTypes.sortAsc | GridHeaderMenuActionTypes.sortDesc | GridHeaderMenuActionTypes.sortUnSort;
}

export const TOOLTIP_TEXT = (monthsHistory = 3): Record<string, string> => ({
  emailStatus: 'Email send status',
  errorMsg: 'Error message (last run)',
  generated: 'Generated on',
  iqStatus: 'IQ process status (auto-order engine)',
  orderId: 'Order ID',
  orderItems: 'Items in order (count)',
  orderSettings: 'Order settings applied',
  owned: 'Owned by current user',
  pdfStatus: 'PDF generation status',
  scheduled: 'Scheduled for',
  status: 'Order status',
  executed: 'Executed on',
  noRecipients: 'No email recipients flag',
  preparedInfo: 'Prepared summary details',
  purchaseOrderNo: 'Purchase order number',

  // Auto Order — IAutoOrderFirestoreOrderItem
  mainSupplier: 'Primary supplier',
  maxReturned: 'Most units returned (from single invoice)',
  maxSold: `Most units sold (from single invoice)`,
  negativeDays: `Days with negative stock on hand (last ${monthsHistory} months)`,
  netSold: `Net units sold (last ${monthsHistory} months)`,
  new: 'New item',
  unitsMonthAvg: 'Average units sold per month (last 12 months)',
  outOfStock: `Times run out of stock (last ${monthsHistory} months)`,
  priceEdits: 'Latest Cost Price',
  qtyDiff: 'Suggested Order Quantity',
  zeroDays: `Days with zero stock on hand (last ${monthsHistory} months)`,

  // DepSales
  name: 'Department name',
  salesYTD: 'Sales year to date',
  grossProfitYTD: 'GP year to date',
  salesPYTD: 'Sales previous YTD',
  grossProfitPYTD: 'GP previous YTD',
  salesToday: 'Sales today',
  grossProfitToday: 'GP today',
  salesMTD: 'Sales month to date',
  grossProfitMTD: 'GP month to date',
  salesPMTD: 'Sales previous MTD',
  grossProfitPMTD: 'GP previous MTD',


  // DepSales2
  customerCount: 'Invoices processed less credit notes',
  netCost: 'Net cost total',
  netSales: 'Net sales total',


  // Supplier
  account: 'Supplier account code',
  adr1: 'Address line 1',
  adr2: 'Address line 2',
  adr3: 'Address line 3',
  adr4: 'Address line 4',
  postC: 'Postal code',
  country: 'Country',
  dlv1: 'Delivery line 1',
  dlv2: 'Delivery line 2',
  dlv3: 'Delivery line 3',
  dlv4: 'Delivery line 4',
  dlvPostC: 'Delivery postal code',
  contact: 'Primary contact',
  terms: 'Payment terms',
  crLimit: 'Credit limit',
  tel1: 'Telephone 1',
  tel2: 'Telephone 2',
  cell: 'Mobile number',
  email: 'Email address',
  taxNo: 'Tax/VAT number',
  current: 'Current balance',
  days30: '30-day balance',
  days60: '60-day balance',
  days90: '90-day balance',
  days120: '120-day balance',
  days150: '150-day balance',
  days180: '180-day or more balance',
  total: 'Total outstanding',
  age: 'Account age',
  onHold: 'On hold status',
  onHoldCode: 'On hold code',
  linkAcc: 'Linked account',
  cCB: 'Internal flag: cCB',
  minOrder: 'Minimum order value',
  addEmails: 'Additional emails',
  emailNames: 'Email recipients',
  isSupplierSelected: 'Supplier selected',
  supplierId: 'Supplier ID',


  // SVCCNumber
  pct: 'Show as percentage',
  negPct: 'Show negatives as %',
  noZero: 'Hide zero values',
  noNeg: 'Hide negative values',
  test: 'Test/display flag',


  // StockItem (+ extensions)
  stockId: 'Stock code',
  code: 'Stock code',
  desc: 'Stock description',
  suppCode: 'Supplier code',
  dep: 'Department',
  subDep: 'Sub-department',
  category: 'Category',
  lastMoved: 'Last movement date',
  lastSold: 'Last sold date',
  lastPurchase: 'Last purchase date',
  prvSellingPri: 'Previous selling price',
  prvSellingPriDate: 'Prev. price date',
  sellPriExcl1: 'Sell price excluding VAT',
  sellPriIncl1: 'Sell price including VAT',
  onHand: 'Current on-hand',
  avCost: 'Average cost',
  latestCost: 'Latest cost',
  stockValue: 'Stock value (latest cost × on hand)',
  gp1: 'GP using average cost',
  recommendedGP: 'Recommended GP',
  suppUsedLast5: 'Supplier last used − 5',
  suppUsedLast4: 'Supplier last used − 4',
  suppUsedLast3: 'Supplier last used − 3',
  suppUsedLast2: 'Supplier last used − 2',
  suppUsedLast1: 'Supplier last used − 1',
  suppUsedLastPrice5: 'Last price − 5',
  suppUsedLastPrice4: 'Last price − 4',
  suppUsedLastPrice3: 'Last price − 3',
  suppUsedLastPrice2: 'Last price − 2',
  suppUsedLastPrice1: 'Last price − 1',
  suppUsedLastDate5: 'Last date − 5',
  suppUsedLastDate4: 'Last date − 4',
  suppUsedLastDate3: 'Last date − 3',
  suppUsedLastDate2: 'Last date − 2',
  suppUsedLastDate1: 'Last date − 1',
  salesOrder: 'Sales order quantity',
  purchaseOrder: 'Purchase order quantity',
  dlvColl: 'Delivery/collection',
  vatR: 'VAT rate',
  reportItemCode: 'Report item code',
  reportItemFactor: 'Report factor',
  regularSuppCode: 'Regular supplier',
  created: 'Created date',
  user: 'User ID created',
  discExempt: 'Discount exempt',
  maxDisc: 'Max discount',
  noDecimal: 'No decimals',
  lineColourCode: 'Line colour code',
  lastStockTake: 'Last stock take date',
  web: 'Web enabled',
  sellUnderCost: 'Allow below cost',
  sellIntoNegative: 'Allow negative stock',
  packSize: 'Pack size',
  unitsYear: 'Units sold last 12 months',
  barcode: 'Barcode',
  binL: 'Bin location',
  ordLvl: 'Order level',
  genCode: 'Generic code',
  excludeSellingValue: 'Exclude from value',
  minOrderLevel: 'Minimum order level',
  maxOrderLevel: 'Maximum order level',
  modified: 'Last modified',
  ['_tags']: 'Tags',
  newlyAdded: 'Newly added item',
  suppName: 'Supplier name',
  storeId: 'Store ID',
  store: 'Store name',
  originalValue: 'Original value',
  disabled: 'Disabled item',
  lineColourDescription: 'Line colour text',
  lineColourValue: 'Line colour value',
  isEdited: 'Locally edited',
  isError: 'Has error',
  isLoading: 'Loading status',
  isModalShown: 'Modal is open',
  isSubmitted: 'Changes submitted',
  errorType: 'Error type',
  nominalGP: 'GP using latest cost',
  diffGP: 'Change in current cost vs previous cost',
  prevGP: 'Previous GP',
  prevCostPrice: 'Previous cost',
  multipleSuppliers: 'Has multiple suppliers',
  supplierDetails: 'Supplier details',


  // IAutoOrderStockItem
  orderQty: 'Order quantity',


  // StockItemUnsafeAdditions
  link: 'External link',
  multipleBarcodes: 'Additional barcodes',


  // ISupplierScheduled
  growth: 'Rate of sales growth expected',
  monthsHistory: 'Months of history',
  period: 'Selected order period',
  stockDays: 'Required stock days',
  userId: 'User ID',


  // AG Grid-only fields
  icons: 'Row action icons',
  isSelected: 'Row selected',
  daysDiff: 'Days between current and last GRV dates',


  // Legacy NGP report column defs
  manuallyAdded: 'Manually added item',
  costMiss: 'Missing cost price',
  createdDate: 'Record created date',
  cratedHasSupp1: 'Has Supplier 1',
});

